/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type AllShoppersModal_viewer = {
    readonly allShoppingWith: ReadonlyArray<{
        readonly groupName: string | null;
        readonly shoppers: ReadonlyArray<{
            readonly name: string | null;
            readonly url: string | null;
        } | null> | null;
    } | null> | null;
    readonly " $refType": "AllShoppersModal_viewer";
};
export type AllShoppersModal_viewer$data = AllShoppersModal_viewer;
export type AllShoppersModal_viewer$key = {
    readonly " $data"?: AllShoppersModal_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"AllShoppersModal_viewer">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "AllShoppersModal_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "allShoppingWith",
      "storageKey": null,
      "args": null,
      "concreteType": "ShoppingWithGroup",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "groupName",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "shoppers",
          "storageKey": null,
          "args": null,
          "concreteType": "ShoppingWithShopper",
          "plural": true,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "name",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "url",
              "args": null,
              "storageKey": null
            }
          ]
        }
      ]
    }
  ]
};
(node as any).hash = '60a9b2a273ddf3a11b7a7da5923481f7';
export default node;
